<template>
  <div id="pointsSales" class="col-12 p-0 ml-4">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN BOLSA DE APOYO -->

        <b-modal id="modal-create-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              agregar Punto de Venta
            </h2>
            <input v-model="nameLN" type="text" class="form-control mt-5 input-vp2"
              placeholder="Nombre del Punto de Venta" />
            <input v-model="code" type="number" class="form-control mt-3 input-vp2" placeholder="Código" />
            <b-form-select class="mt-3" v-model="selectedlb" :options="optionslb" @change="getZones"></b-form-select>
            <b-form-select v-if="optionsZ[1]" class="mt-3" v-model="selectedZ" :options="optionsZ"></b-form-select>
            <div v-if="errorLineBusiness" class="alert alert-info mt-3 mb-4" role="alert">
              {{ error.message }}
            </div>

            <div style="display: flex" class="mt-4">
              <button :disabled="
                code == '' ||
                nameLN == '' ||
                selectedlb.name == 'default' ||
                (optionsZ[1] ? selectedZ.id == null : false)
              " @click="nextStep1PS('next')" type="button" class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none">
                <span class="cta">Guardar Cambios</span>
              </button>
              <button type="button" class="button-secundary ml-4" style="margin: auto"
                @click="$bvModal.hide('modal-create-ps')">
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN BOLSA DE APOYO -->

        <b-modal id="modal-create2-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de guardar este Punto de Venta?
            </h3>
            <p class="pt-5">
              <span class="text-uppercase font-weight-bold">{{ nameLN }}</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Código: </span>{{ code }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Lineas de Negocio: </span>{{ selectedlb.name }}
            </p>
            <p v-if="selectedZ.id" style="font-size: 16px">
              <span class="font-weight-bold">Zona: </span>{{ selectedZ.name }}
            </p>

            <div style="display: flex" class="pt-2">
              <button type="button" class="button-secundary mr-4" style="margin: auto" @click="nextStep1PS('previous')">
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button @click="nextStep1PS('save')" type="button" class="button-primary enviar-mensaje ml-4"
                style="border: none">
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN LINEA DE NEGOCIO -- EXITOSO  -->

        <b-modal id="modal-create3-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/checkbox-circle-line.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button @click="$bvModal.hide('modal-create3-ps')" type="button" class="button-primary enviar-mensaje"
              style="border: none">
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.trace" id="modal-fail-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.trace.message[0] }}</p>

            <button class="mt-2 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail-ps')">
              Entendido
            </button>
          </div>
        </b-modal>

        <b-modal id="modal-error" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ msgError }}</p>
            <button class="mt-2 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail-bk')">
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal v-if="pointsSale" id="modal-edit-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Editar Punto de Venta
            </h2>
            <input v-model="nameLN" type="text" class="form-control mt-5 input-vp2"
              placeholder="Nombre del Punto de Venta" />
            <input v-model="code" type="number" class="form-control mt-3 input-vp2" placeholder="Código" />
            <b-form-select class="mt-3" v-model="selectedlb" :options="optionslb" @change="getZones"></b-form-select>
            <b-form-select v-if="optionsZ[1]" class="mt-3" v-model="selectedZ" :options="optionsZ"></b-form-select>
            <div v-if="errorLineBusiness" class="alert alert-info mt-3" role="alert">
              {{ error.message }}
            </div>

            <div style="display: flex" class="mt-4">
              <button :disabled="
                code == '' ||
                nameLN == '' ||
                selectedlb.name == 'default' ||
                (optionsZ[1] ? selectedZ.id == null : false)
              " @click="nextStep2PS('next')" type="button" class="button-primary enviar-mensaje mr-4"
                style="border: none">
                <span class="cta">Guardar Cambios</span>
              </button>
              <button class="delete button-primary enviar-mensaje ml-4" type="button" @click="nextStep2PS('nextD')">
                <img src="@/assets/images/icons/delete_trash_white.svg" />
                <span class="cta ml-2"> Borrar Punto de venta</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit2-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de modificar este Punto de Venta?
            </h3>
            <p class="pt-5">
              <span class="font-weight-bold">Nombre: </span>
              {{ nameLN }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Código: </span>{{ code }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Lineas de Negocio: </span>{{ selectedlb.name }}
            </p>
            <p v-if="selectedZ.id" style="font-size: 16px">
              <span class="font-weight-bold">Zona: </span>{{ selectedZ.name }}
            </p>

            <div style="width: 100%; display: flex; margin-top: 32px">
              <button type="button" class="button-secundary" style="margin: auto" @click="nextStep2PS('previous')">
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button @click="nextStep2PS('edit')" type="button" class="button-primary enviar-mensaje"
                style="border: none">
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit3-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/checkbox-circle-line.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>

            <button @click="$bvModal.hide('modal-edit3-ps')" type="button" class="button-primary enviar-mensaje"
              style="border: none">
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR LINEA DE NEGOCIO -->

        <b-modal id="modal-delete-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de eliminar el punto de venta?
            </h3>
            <p class="pt-5 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-5">
              <span class="text-uppercase">{{ nameLN }}</span>
            </p>
            <div style="display: flex" class="mt-2">
              <button type="button" class="button-secundary mr-4" style="margin: auto" @click="nextStep2PS('previous')">
                <span class="cta">No borrar</span>
              </button>
              <button class="delete button-primary enviar-mensaje ml-4" type="button" @click="nextStep2PS('delete')">
                <img src="@/assets/images/icons/delete_trash_white.svg" alt="" />
                <span class="cta ml-2"> Borrar punto de venta</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 5 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-delete2-ps" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/checkbox-circle-line.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>

            <button @click="$bvModal.hide('modal-delete2-ps')" type="button" class="button-primary enviar-mensaje"
              style="border: none">
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Punto de venta -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Punto de Venta +" @nuevo="create"></AddCategory>
      </div>
          </div>
    
    <div class="row">
   
      <div class="col-md-8 col-sm-12 mt-4">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Puntos de Venta</h3>
          </div>
          <div class="col-md-8 col-sm-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input type="search" placeholder="Buscar Punto de Venta" aria-label="Buscar Punto de Venta"
                autocomplete="off" class="form-control body_regular" v-model="filter" style="border: 0px"
                @keydown="startTipyng()" @keyup="finishTipyng()" />
            </div>
          </div>
      
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable :columns="datatable.columns" :data="datatable.rows" :filter="datatable.filter"
              :per-page="datatable.perPage" :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless">
              <template slot-scope="{ row, columns }">
                <tr @click="editPointsSales(row)">
                  <template>
                    <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
              <Pagination :data="pointsSales.data" :limit="10" @pagination-change-page="getFilterDp">
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
export default {
  name: "LineBusiness",
  components: { Pagination, SelectSettings, AddCategory },
  data() {
    return {
      msgError: "",
      selectedlb: { id: 0, name: "default" },
      selectedZ: { id: null, name: "" },
      optionslb: [
        { value: { id: 0, name: "default" }, text: "Asigna una categoria" },
      ],
      optionsZ: [
        { value: { id: null, name: "" }, text: "Seleccione una Zona" },
      ],
      code: "",
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      filter: "",
      errorLineBusiness: false,
      datatable: {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.getPointsSales();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "lineDeals",
      "zones",
      "pointsSales",
      "pointsSale",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actLineDeals",
      "actGetZonesByLB",
      "actPointsSales",
      "actPointSales",
      "actSavePointSale",
      "actUpdatePointSale",
      "actDeletePointSale",
    ]),

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 1500);
    },

    getPointsSales() {
      let page = [];
      page = {
        page: this.datatable.page,
      };

      this.actPointsSales(page).then(() => {
        if (this.lineDeals.data) {
          this.pointsSales.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
              line_deal_name: x.line_deal_name,
            });
          });
        }
      });
      this.loadRows();
    },

    create() {
      this.nameLN = "";
      this.code = "";
      this.selectedlb = { id: 0, name: "default" };
      this.selectedZ = { id: null, name: "" };
      this.optionsZ = [
        { value: { id: null, name: "" }, text: "Seleccione una Zona" },
      ];
      this.$root.$emit("bv::show::modal", "modal-create-ps");
      this.errorLineBusiness = false;
    },

    getZones() {
      this.selectedZ = { id: null, name: "" };
      this.optionsZ = [
        { value: { id: null, name: "" }, text: "Seleccione una Zona" },
      ];

      this.actGetZonesByLB(this.selectedlb.id).then(() => {
        this.errorLineBusiness = false;
        if (this.zones.data) {
          this.zones.data.forEach((x) => {
            this.optionsZ.push({
              value: { id: x.id, name: x.name },
              text: x.name,
            });
            if (this.pointsSale.pro_zone_id) {
              this.optionsZ.forEach((x) => {
                if (x.value.id === this.pointsSale.pro_zone_id) {
                  this.selectedZ = x.value;
                }
              });
            }
          });
        } else {
          this.errorLineBusiness = true;
          this.selectedZ = { id: null, name: "" };
          this.optionsZ = [
            { value: { id: null, name: "" }, text: "Seleccione una Zona" },
          ];
        }
      });
    },
    nextStep1PS(x) {
      let data = {
        name: this.nameLN,
        code: this.code,
        pro_line_deal_id: this.selectedlb.id,
        pro_zone_id: this.selectedZ.id,
        status: 1,
      };
      switch (x) {
        case "next":
          if (!this.optionsZ[1]) {
            this.selectedZ = { id: null, name: "" };
          }
          this.$root.$emit("bv::hide::modal", "modal-create-ps");
          this.$root.$emit("bv::show::modal", "modal-create2-ps");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-ps");
          this.$root.$emit("bv::show::modal", "modal-create-ps");
          break;
        case "save":
          this.actSavePointSale(data)
            .then(() => {
              if (this.error.data) {
                this.$root.$emit("bv::hide::modal", "modal-create2-ps");
                this.$root.$emit("bv::show::modal", "modal-fail-ps");
                this.getPointsSales();
                return;
              } else {
                this.nameLN = "";
                this.selectedlb = { id: 0, name: "default" };
                this.optionssc = [
                  {
                    value: { id: 0, name: "default" },
                    text: "Asigna una linea de Negocio",
                  },
                ];
                this.$root.$emit("bv::hide::modal", "modal-create2-ps");
                this.$root.$emit("bv::show::modal", "modal-create3-ps");
              }
            })
            .catch((a) => {
              this.msgError = a.response.data.message;
              this.$root.$emit("bv::hide::modal", "modal-create2-ps");
              this.$root.$emit("bv::show::modal", "modal-error");
            });
          this.getPointsSales();
          break;
        default:
      }
    },
    loadRows() {
      this.optionslb = [
        { value: { id: 0, name: "default" }, text: "Asigna una categoria" },
      ];
      let filter = {
        filter: "filter",
      };
      this.actLineDeals(filter).then(() => {
        this.lineDeals.data.forEach((x) => {
          this.optionslb.push({
            value: {
              id: x.id,
              name: x.name,
            },
            text: x.name,
          });
        });
      });
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Punto de Venta",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Linea de Negocio",
          field: "line_deal_name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Código",
          field: "code",
          align: "left",
          headerClass: "theading",
        },
      ];
    },
    editPointsSales(row) {
      this.nameLN = "";
      this.code = "";
      this.selectedlb = { id: 0, name: "default" };
      this.selectedZ = { id: null, name: "" };
      this.errorLineBusiness = false;
      this.actPointSales(row.id).then(() => {
        this.nameLN = this.pointsSale.name;
        this.code = this.pointsSale.code;
        this.optionslb.forEach((x) => {
          if (x.value.id === this.pointsSale.pro_line_deal_id) {
            this.selectedlb = x.value;
            this.getZones();
          }
        });
      });
      this.$root.$emit("bv::show::modal", "modal-edit-ps");
    },
    nextStep2PS(x) {
      let data = {
        name: this.nameLN,
        code: this.code,
        pro_line_deal_id: this.selectedlb.id,
        pro_zone_id: this.selectedZ.id,
        status: 1,
        id: this.pointsSale.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-ps");
          this.$root.$emit("bv::show::modal", "modal-edit2-ps");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-ps");
          this.$root.$emit("bv::hide::modal", "modal-delete-ps");
          this.$root.$emit("bv::show::modal", "modal-edit-ps");
          break;
        case "edit":
          this.actUpdatePointSale(data).then(() => {
            if (this.error.data) {
              this.nameLN = "";
              this.selectedlb = { id: 0, name: "default" };
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-create2-ps");
              this.$root.$emit("bv::show::modal", "modal-fail-ps");
              this.getPointsSales();
              return;
            } else {
              this.nameLN = "";
              this.selectedlb = { id: 0, name: "default" };
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-edit2-ps");
              this.$root.$emit("bv::show::modal", "modal-edit3-ps");
              this.getPointsSales();
            }
            this.getPointsSales();
          });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-ps");
          this.$root.$emit("bv::show::modal", "modal-delete-ps");
          break;
        case "delete":
          this.actDeletePointSale(this.pointsSale.id)
            .then(() => {
              this.nameLN = "";
              this.selectedlb = { id: 0, name: "default" };
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-delete-ps");
              this.$root.$emit("bv::show::modal", "modal-delete2-ps");
              this.loadRows();
            })
            .catch((error2) => {
              let error = {
                trace: {
                  message: [error2.response.data.message],
                },
              };
              this.actSetError(error).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-delete-ps");
                this.$root.$emit("bv::show::modal", "modal-fail");
                this.getPointsSales();
              });
            });
          break;
        default:
      }
    },

    getFilterDp(page = 1) {
      let data2 = [];
      data2 = {
        page: page,
        filter: this.filter,
      };
      this.actPointsSales(data2).then(() => {
        this.datatable.rows = [];
        if (this.lineDeals.data) {
          this.pointsSales.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
              line_deal_name: x.line_deal_name,
            });
          });
        }
      });
      this.loadRows();
    },
  },
};
</script>
<style lang="scss">
#pointsSales {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }

  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;

    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }

    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }

    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }

    .theading {
      padding: 15px 15px;
    }

    tbody tr {
      border-radius: 10px;
    }

    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }

    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>